export default "__VITE_ASSET__Di_BT239__"